export const toNumber = (param: number | string) => {
  const value = Number(param);

  if (Number.isNaN(value)) {
    return 0;
  }

  return value;
};
